import cc from 'currency-codes';

const prefixCurrencyMapping: { [key: string]: string } = {
    SEK: '+46',
    NOK: '+47',
    DKK: '+45',
    GBP: '+44',
    ISK: '+354',
    EUR: '+49', // germany for now
};

export const getPhonePrefixFromCurrency = (currency: cc.CurrencyCodeRecord | undefined): string => {
    const key = (currency && currency.code) || '';
    return getPhonePrefixFromCurrencyString(key);
};

export const getPhonePrefixFromCurrencyString = (currency: string | undefined): string => {
    return prefixCurrencyMapping[currency || ''] || '+47';
};
